// =============================================================================
// EmptyState - Stato vuoto riutilizzabile (icona + titolo + testo + azione)
// =============================================================================

import { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '../../lib/utils';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  /** Azione opzionale (es. un bottone) mostrata sotto il testo */
  action?: ReactNode;
  /** Compatto per spazi ridotti (card piccole) */
  size?: 'sm' | 'md';
  className?: string;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  size = 'md',
  className,
}: EmptyStateProps) {
  const iconWrap = size === 'sm' ? 'w-12 h-12' : 'w-16 h-16';
  const iconSize = size === 'sm' ? 'w-6 h-6' : 'w-8 h-8';

  return (
    <div className={cn('flex flex-col items-center justify-center text-center px-4 py-8', className)}>
      <div className={cn('rounded-full bg-gray-50 flex items-center justify-center mb-3', iconWrap)}>
        <Icon className={cn('text-gray-300', iconSize)} strokeWidth={1.75} />
      </div>
      <p className="text-sm font-medium text-gray-700">{title}</p>
      {description && (
        <p className="mt-1 text-sm text-gray-400 max-w-xs">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export default EmptyState;
